import React from 'react';

import Banner from '../../components/Banner';
import ArticleSpreader from '../../components/ArticleSpreader';
import Paragraph from '../../components/Paragraph';
import ParagraphWithImage from '../../components/ParagraphWithImage';
import Accentuation from '../../components/Accentuation';
import Fact from '../../components/Fact';
import Quote from '../../components/Quote';
import RightBanner from '../../components/RightBanner';
import Slider from '../../components/Slider';
import Roles from '../../components/Roles';
import LeftBanner from '../../components/LeftBanner';
import Article from '../../components/Article';
import EndSpreader from '../../components/EndSpreader';
import MoreArticles from '../../components/MoreArticles';
import BarChart from '../../components/BarChart';

import { Helmet } from 'react-helmet';

const DigitalPage = props => (
  <div>
    <Helmet>
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Цифровые капиталы - Специальный проект Alfa Private"
      />
      <meta content="Private Banking в России" property="og:description" />
      <meta
        property="og:url"
        content="http://special.kommersant.ru/alfa-private/"
      />
      <meta
        property="og:image"
        content="http://special.kommersant.ru/alfa-private/images/sharing-digital.jpg"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="article:published_time" content="2018-11-09" />
      <title>Цифровые капиталы - Специальный проект Alfa Private</title>
    </Helmet>
    <Article
      banner={
        <Banner
          title="Цифровые капиталы"
          backgroundImage="images/banners/bg.jpg"
        />
      }
      location={props.location}
      showSocialSharing
    >
      {[
        {
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  <img src="images/media/zahod211.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  В&nbsp;отличие от&nbsp;банковской розницы в&nbsp;сегменте
                  Private Banking цифровизация началась не&nbsp;так давно.
                  Однако список внедряемых технологий уже значителен:
                  виртуальные переговорные с&nbsp;финансовыми советниками
                  в&nbsp;3D, мобильные приложения с&nbsp;персонализированным
                  контентом, биометрическая идентификация, в&nbsp;том числе
                  и&nbsp;депозитарии с&nbsp;доступом 24 часа. Эти сервисы
                  позволяют клиенту вне зависимости от&nbsp;места и&nbsp;времени
                  не&nbsp;только распоряжаться сбережениями, но&nbsp;
                  и&nbsp;отслеживать, на&nbsp;какой стадии находятся
                  поставленные перед банком задачи.
                </Paragraph>
                <Paragraph>
                  Банкиры, работающие с высокосостоятельными клиентами, нередко
                  начинают свои рассказы о ситуации в отрасли с описания того,
                  что, по их мнению, повышает лояльность вкладчиков. Как
                  оказывается на практике, построить доверительные партнерские
                  отношения с клиентами удается далеко не всем банкирам и далеко
                  не всем банкам.
                </Paragraph>
                <Paragraph>
                  Что&nbsp;бы вы&nbsp;сказали, если&nbsp;бы вам предложили
                  надеть футуристический шлем с&nbsp;подключенными к&nbsp;нему
                  электродами и&nbsp;отвечать несколько часов на&nbsp;вопросы?
                  И&nbsp;все эти манипуляции проводятся не&nbsp;в&nbsp;клинике,
                  а&nbsp;в&nbsp;отделении банка. Конечно, вам объяснили&nbsp;бы,
                  что речь идет о&nbsp;суперпопулярном на&nbsp;Западе
                  высокотехнологичном исследовании, так называемом
                  нейромаркетинге, во&nbsp;время которого выясняется
                  эмоциональный фон, реакция человека на&nbsp;тот или иной
                  продукт. Скорее всего, вы&nbsp;ответили&nbsp;бы отказом.
                </Paragraph>
                <Fact>
                  Пользуясь мобильным приложением Альфа Private, клиенты могут
                  видеть свою консолидированную позицию, то есть картину по всем
                  активам, в разрезе категорий
                </Fact>
                <Paragraph>
                  В&nbsp;случае исследования клиентов розничного банковского
                  сегмента и&nbsp;даже клиентов с&nbsp;доходом выше среднего
                  находились те, кому этот эксперимент был интересен.{' '}
                  <Accentuation>
                    Однако перед{' '}
                    <a
                      href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                      target="_blank"
                    >
                      Альфа-Банком
                    </a>
                    , который проводил подобное интервьюирование, стояла
                    нетривиальная задача, поскольку банку были интересны клиенты
                    сегмента Private Banking.
                  </Accentuation>
                </Paragraph>
                <Paragraph>
                  Сейчас в&nbsp;Альфа Private обслуживается несколько тысяч
                  высокосостоятельных клиентов и&nbsp;их&nbsp;семей. И&nbsp;этих
                  людей нельзя распределить на&nbsp;какие-то группы. &laquo;Если
                  вы&nbsp;возьмете десять клиентов Альфа Private, все они будут
                  абсолютно разными&raquo;,&nbsp;&mdash; говорит управляющий
                  директор по развитию продуктов{' '}
                  <a
                    href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                    target="_blank"
                  >
                    Альфа Private
                  </a>{' '}
                  Антон Рахманов.
                </Paragraph>
                <Paragraph>
                  <Quote
                    author={{
                      photo: 'images/media/rahmanov1.jpg',
                      nick: 'Антон Рахманов',
                      job1: 'Альфа Private',
                      position: 'Управляющий директор по развитию продуктов',
                    }}
                  >
                    Наши клиенты привыкли к&nbsp;digital и&nbsp;ждут этого,
                    в&nbsp;том числе и&nbsp;от&nbsp;нас. Они точно так&nbsp;же
                    пользуются приложениями разных банков, госуслугами, ведут
                    свой бизнес. Они часто бывают за&nbsp;рубежом, пользуются
                    каршерингом, различными сервисами бронирования, совершают
                    покупки в&nbsp;онлайн-магазинах. И&nbsp;они привыкли видеть
                    текущий статус их&nbsp;заказа&nbsp;&mdash; машины, посылки
                    и&nbsp;так далее. То&nbsp;есть они привыкли быть
                    осведомленными. И&nbsp;мы&nbsp;стремимся к&nbsp;тому, чтобы
                    предоставлять возможность клиенту из&nbsp;любого канала,
                    будь то&nbsp;WhatsApp или мессенджер в&nbsp;мобильном
                    приложении, не&nbsp;просто отдать какое-то распоряжение,
                    но&nbsp;и&nbsp;отследить, что происходит с&nbsp;задачами,
                    которые он&nbsp;поставил.
                  </Quote>
                </Paragraph>
                <Paragraph>
                  Среди высокосостоятельных клиентов банка есть люди с&nbsp;
                  большим оборотом бизнеса, у&nbsp;которых мало средств в&nbsp;
                  свободно инвестируемой форме, потому что они вложены
                  в&nbsp;дело. И&nbsp;есть люди из&nbsp;списка Forbes, которых
                  финансирует Альфа-Банк. Представить себе, что этих инвесторов
                  можно пригласить принять участие в&nbsp;таком исследовании как
                  нейромаркетинг довольно сложно. Тем не&nbsp;менее, такой
                  эксперимент провели. Для некоторых клиентов основной
                  мотивацией стало желание стать инфлюэнсерами, потому что
                  именно на&nbsp; основе их&nbsp;мнения банк будет создавать
                  новые высокотехнологичные продукты. Все они, несмотря на&nbsp;
                  свой статус и&nbsp;занятость, с&nbsp;пониманием отнеслись
                  к&nbsp;предложению, потому что у&nbsp;них сложились давние,
                  доверительные и&nbsp;хорошие партнерские отношения
                  с&nbsp;Альфа-Банком.
                </Paragraph>
              </ArticleSpreader>

              <Paragraph>
                <RightBanner image="images/media/digital12.jpg">
                  Высокосостоятельные клиенты сегодня – люди, преимущественно
                  использующие новые технологии
                </RightBanner>
              </Paragraph>
            </div>
          ),
        },
        {
          title: 'Деньги в новом измерении',
          banner: (
            <Banner
              title="Private Banking: обзор"
              backgroundImage="images/banners/bg.jpg"
            />
          ),
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  Необходимость в&nbsp;исследованиях клиентских цифровых
                  предпочтений в&nbsp;Private Banking возникла не&nbsp;случайно.
                  Банки давно стали флагманами цифровизации, однако сегмент
                  Private Banking долгое время оставался в&nbsp;стороне
                  от&nbsp;этого тренда. И&nbsp;если розничный массовый сегмент
                  уже успел пройти путь цифровизации, внедряя множество
                  дистанционных сервисов, и&nbsp;сейчас стоит на&nbsp;этапе
                  цифровой трансформации, когда банки уже отказываются
                  от&nbsp;одних технологий в&nbsp;пользу других, в&nbsp;Private
                  Banking этот процесс начался сравнительно недавно.
                </Paragraph>
              </ArticleSpreader>

              <ArticleSpreader>
                <Paragraph>
                  Одной из&nbsp;особенностей сегмента Private всегда было{' '}
                  <Accentuation>
                    личное взаимодействие между клиентами и&nbsp;банком.{' '}
                  </Accentuation>
                  Общение финансовых советников с&nbsp;инвесторами
                  до&nbsp;последнего времени оставалось
                  &laquo;аналоговым&raquo;, поскольку все клиентские запросы
                  решались с&nbsp;помощью звонков по&nbsp;телефону или
                  на&nbsp;личных встречах. Естественно, эти отношения
                  становились более технологичными, переходили
                  в&nbsp;мессенджеры. Но, так или иначе, сегмент Private Banking
                  дольше других финансовых секторов жил по&nbsp;старинке.
                </Paragraph>
                <Paragraph>
                  Совершено очевидно при этом, что и&nbsp;высокосостоятельные
                  клиенты сегодня&nbsp;&mdash; люди, преимущественно
                  использующие новые технологии. Они активно пользуются
                  digital-сервисами, которые быстры, понятны, помогают им&nbsp;{' '}
                  <Accentuation>
                    {' '}
                    оперативно достигать какого-либо результата
                    и&nbsp;оптимизировать свое время.{' '}
                  </Accentuation>
                  Но&nbsp;также очевидно, что им&nbsp;необходим эксклюзив,
                  в&nbsp;том числе и&nbsp;в&nbsp;&laquo;цифре&raquo;.
                </Paragraph>
              </ArticleSpreader>
              <ParagraphWithImage image="images/media/vr1.jpg">
                В&nbsp;этом году{' '}
                <a
                  href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                  target="_blank"
                >
                  Альфа Private
                </a>{' '}
                запустил пилотный проект по&nbsp;созданию виртуального
                помощника&nbsp;&mdash; VR-консультанта. Эта технология позволяет
                клиенту вне зависимости от&nbsp;места его нахождения встретиться
                в&nbsp;удобное время с&nbsp;личным финансовым или инвестиционным
                советником и&nbsp;получить консультацию, просто надев
                VR-гарнитуру и&nbsp;подключившись к&nbsp;виртуальной
                переговорной. В&nbsp;режиме реального времени клиент сможет
                обсудить нужные вопросы с&nbsp;советником, который предстает
                в&nbsp;виде 3D-аватара, а&nbsp;также увидеть всю информацию
                о&nbsp; своих активах и&nbsp;тратах. Это дает возможность
                работать в&nbsp;интерактивном формате с&nbsp;реальными цифрами,
                визуализировать их&nbsp;в&nbsp;виде графиков и&nbsp;выполнять
                многие другие операции. И&nbsp;еще&nbsp;&mdash; разговаривать
                с&nbsp;живым человеком, а&nbsp;не&nbsp;с&nbsp;роботом.
              </ParagraphWithImage>
              <ArticleSpreader>
                <Roles title="Три кита цифровизации Альфа Private">
                  {[
                    {
                      title: 'VR-помощник',
                      description: 'Удаленные консультации',
                      icon: 'images/roles/vr2.png',
                    },
                    {
                      title: 'Мобильное приложение',
                      description:
                        'Финансовый радар для клиентов  Альфа Private',
                      icon: 'images/roles/cell1.png',
                    },
                    {
                      title: 'Биометрический депозитарий',
                      description: 'Доступ по сканированию рисунка вен',
                      icon: 'images/roles/bank2.png',
                    },
                  ]}
                </Roles>
                <Paragraph>
                  В&nbsp;этом проекте большое внимание было уделено
                  безопасности. По&nbsp;словам разработчиков, этот вопрос был
                  проработан в&nbsp; первую очередь. Во-первых, финансовый
                  советник может инициировать VR-сессию только после устной
                  договоренности с&nbsp;клиентом. Во-вторых, клиенту будет
                  необходимо подтвердить операцию через приложение мобильного
                  банка{' '}
                  <a
                    href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                    target="_blank"
                  >
                    Альфа-Мобайл
                  </a>
                  : он&nbsp;получает соответствующее оповещение, после чего
                  заверяет запрос кодом из&nbsp;СМС. Это дает виртуальной
                  переговорной несколько степеней защиты. И&nbsp;только после
                  подтверждения кода запускается виртуальная переговорная
                  комната, в&nbsp;которую подгружаются данные клиента.
                </Paragraph>
                <Paragraph>
                  Пока это пилотный проект, и&nbsp;он&nbsp;не&nbsp;завершен,
                  поскольку банк тестирует концепт на&nbsp;отдельной группе
                  клиентов. Но, как ожидается, в&nbsp;скором будущем эта услуга
                  станет доступной всем клиентам Альфа Private&nbsp;&mdash;
                  достаточно будет обратиться к&nbsp;своему менеджеру, чтобы
                  получить доступ к&nbsp;виртуальной переговорной.
                </Paragraph>
                <Paragraph>
                  &laquo;Мы&nbsp;знаем, что наши клиенты часто путешествуют или
                  постоянно проживают за&nbsp;рубежом и&nbsp;очень бережно
                  относятся к&nbsp;собственному времени. Визит в&nbsp;офис для
                  них может быть не&nbsp;всегда удобен, при этом общение в&nbsp;
                  чате с&nbsp;советником не&nbsp;даст эффекта присутствия
                  и&nbsp;доверительной атмосферы, погружения в&nbsp;контекст.
                  Поэтому мы&nbsp;уверены, что многие клиенты оценят удобство
                  виртуального помощника&raquo;,&nbsp;&mdash; говорит Антон
                  Рахманов. В&nbsp;будущем в&nbsp;виртуальной переговорной
                  появится и&nbsp;функция автоматической отправки отчета
                  о&nbsp;принятых решениях.{' '}
                  <Accentuation>
                    Раньше клиент звонил своему финансовому советнику, тот
                    готовил инвестиционное предложение, и&nbsp;на&nbsp; все это
                    уходило время. А&nbsp;с&nbsp;технологией виртуальной
                    реальности это займет буквально несколько минут.
                  </Accentuation>
                </Paragraph>
              </ArticleSpreader>
            </div>
          ),
        },
        {
          title: 'Богатство приложений',
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  <Accentuation>
                    В&nbsp;начале октября{' '}
                    <a
                      href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                      target="_blank"
                    >
                      Альфа-Банк
                    </a>{' '}
                    удивил конкурентов в&nbsp;сегменте Private Banking, запустив
                    отдельное приложение для клиентов Альфа Private.{' '}
                  </Accentuation>
                  &laquo;Для нас это, пожалуй, сейчас самый большой челлендж.
                  Все спрашивают нас&nbsp;&mdash; зачем? Зачем мы&nbsp;сделали
                  еще одно приложение, когда у&nbsp;клиентов есть мобильный
                  банк&raquo;,&nbsp;&mdash; говорит Антон Рахманов.
                </Paragraph>
                <Fact>
                  Следующим этапом развития приложения Альфа Private будет
                  персонализация предложений и&nbsp;услуг&nbsp;&mdash; это будут
                  все те&nbsp;же инвестиционные, банковские или партнерские
                  продукты, а&nbsp;также lifestyle
                </Fact>
                <Paragraph>
                  Дело в&nbsp;том, что в&nbsp;результате проведенных
                  исследований по&nbsp;нейромаркетингу специалисты Альфа Private
                  выяснили одну интересную вещь. Оказалось, что клиенты Private
                  Banking проводят очень мало времени в&nbsp; мобильном банке,
                  потому что считают его неким финансовым
                  &laquo;комбайном&raquo; самообслуживания, куда можно загрузить
                  платежки, подтвердить операции или сделать перевод. Это
                  примерно такая&nbsp;же рутинная работа, которую осуществляет
                  домохозяйка, водитель, курьер. В&nbsp;результате клиенты
                  Private Banking предпочитают не&nbsp;сами совершать операции
                  в&nbsp;мобильном банке, а&nbsp;поручают делать это доверенным
                  лицам&nbsp;&mdash; супругам, детям или наемным работникам. При
                  этом самим клиентам требуется полная картина, некий финансовый
                  радар того, что происходит с&nbsp;их&nbsp;капиталом,
                  инвестициями, средствами в&nbsp;доверительном управлении,
                  поскольку они владеют продуктами не&nbsp;только Альфа-Банка,
                  а&nbsp;также и&nbsp;других партнеров, входящих в&nbsp;состав
                  Альфа Групп&nbsp;&mdash; Альфа-Капитал, АльфаСтрахование,
                  Альфа-Директ, АльфаФорекс и&nbsp;другие. В&nbsp;рамках{' '}
                  <a
                    href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                    target="_blank"
                  >
                    Альфа-Мобайл
                  </a>{' '}
                  клиент не&nbsp;мог видеть целиком эту картину.
                </Paragraph>
                <Paragraph>
                  Теперь, пользуясь мобильным приложением Альфа Private, клиенты
                  могут видеть свою консолидированную позицию, то&nbsp;есть
                  картину по&nbsp;всем активам, в&nbsp;разрезе
                  категорий&nbsp;&mdash; инвестиционные продукты, страховые
                  продукты, банковские продукты и т. п. Одновременно с этим
                  приложение дает возможность удобно пересчитывать активы
                  в&nbsp;основные валюты портфеля, фильтровать продукты
                  по&nbsp;валютам. Иными словами,{' '}
                  <Accentuation>
                    клиент получает удобный просмотровый инструмент, который
                    дает ему понимание о&nbsp;том, сколько у&nbsp;него средств,
                    в&nbsp;каких активах и&nbsp; в&nbsp;каких валютах они
                    размещены и&nbsp;с&nbsp;каким финансовым результатом.
                  </Accentuation>
                </Paragraph>
              </ArticleSpreader>
              <Paragraph>
                <LeftBanner image="images/banners/black-banner.jpg">
                  Клиенты Private Banking привыкли быть осведомленными и
                  отслеживать, что происходит с задачами, которые они поставили
                </LeftBanner>
              </Paragraph>
              <ArticleSpreader>
                <Paragraph>
                  На&nbsp;вопрос, почему разработчики не&nbsp;добавили этот
                  функционал в&nbsp;мобильное приложение Альфа-Банка, те&nbsp;
                  отвечают, что таким образом усложнили&nbsp;бы его,
                  сделали&nbsp; бы слишком многослойным. А&nbsp;клиенты,
                  на&nbsp;которых оно ориентировано, хотят пользоваться
                  простыми, удобными и&nbsp; понятными сервисами. Именно поэтому
                  было принято решение сделать его отдельно от&nbsp;мобильного
                  банка.
                </Paragraph>
                <Paragraph>
                  Следующим этапом развития приложения Альфа Private будет
                  персонализация предложений и&nbsp;услуг&nbsp;&mdash; это будут
                  все те&nbsp;же инвестиционные, банковские или партнерские
                  продукты, а&nbsp;также lifestyle. Но&nbsp;они будут
                  персонализироваными и&nbsp;актуальными для клиента
                  в&nbsp;конкретный момент времени. Благодаря сложным системам
                  анализа Big Data, которые будут доведены до&nbsp;максимальной
                  автоматизации, из&nbsp;всего объема предложений,
                  с&nbsp;которым к&nbsp;нему хотят выйти партнеры банка,
                  пользователь будет получать только то, что для него актуально.
                </Paragraph>
              </ArticleSpreader>
            </div>
          ),
        },
        {
          title: 'Конфиденциальность и безопасность',
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  В&nbsp;октябре в&nbsp;новом флагманском представительстве{' '}
                  <a
                    href="
https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
                    target="_blank"
                  >
                    Альфа Private
                  </a>{' '}
                  в&nbsp;Денежном переулке в&nbsp;Москве появился уникальный
                  продукт, призванный обеспечить высокосостоятельным клиентам
                  не&nbsp;только безопасность, но&nbsp;и&nbsp;конфиденциальность
                  при работе с&nbsp;банковской ячейкой. Речь
                  о&nbsp;автоматическом биометрическом депозитарии.
                </Paragraph>
                <Fact>
                  Биометрическое сканирование вен в сочетании с наличием карты
                  доступа и ключа от ячейки, исключает несанкционированный
                  доступ
                </Fact>
                <Paragraph>
                  <Accentuation>
                    Теперь для доступа к&nbsp;ячейке не&nbsp;нужно присутствие
                    сотрудника банка:{' '}
                  </Accentuation>
                  клиент проходит в&nbsp;преддепозитарий при помощи карты
                  доступа, а&nbsp;нужная ячейка вызывается после сканирования
                  рисунка вен ладони клиента.
                </Paragraph>
                <Paragraph>
                  Сканирование вен проводится в&nbsp;инфракрасном освещении,
                  которое проходит сквозь кожу и&nbsp;отражается непосредственно
                  от&nbsp;кровеносных сосудов&nbsp;&mdash; это не&nbsp;позволяет
                  использовать муляжи для обмана системы. Такой тип
                  биометрической аутентификации относится к&nbsp;наиболее
                  надежным и, в&nbsp;сочетании с&nbsp;наличием карты доступа
                  и&nbsp;ключа от&nbsp;ячейки, исключает несанкционированный
                  доступ.
                </Paragraph>
                <Paragraph>
                  Пока новый депозитарий доступен клиентам в&nbsp;рабочие часы
                  отделения&nbsp;&mdash; чтобы сотрудники имели возможность
                  максимально оперативно отвечать на&nbsp;клиентские вопросы,
                  но&nbsp;уже в&nbsp;ноябре он&nbsp;будет работать 24 часа
                  в&nbsp;сутки 7 дней в&nbsp;неделю.
                </Paragraph>
                <EndSpreader />
                <MoreArticles
                  articles={[
                    {
                      title: 'Private Banking - от финансов до стиля жизни',
                      url: '/overview',
                      background: 'images/media/anons1.jpg',
                    },
                    {
                      title: 'Забота о благосостоянии',
                      url: '/invest',
                      background: 'images/media/anons3.jpg',
                    },
                    {
                      title: 'Наш внутренний девиз — у нас всегда есть решение»',
                      url: '/interview',
                      background: 'images/media/anons4.jpg',
                    },
                  ]}
                />
              </ArticleSpreader>
            </div>
          ),
        },
      ]}
    </Article>
  </div>
);

export default DigitalPage;
